<template>
  <div class="home" ref="mBox">
    <div class="home-con" v-on:click="goToYu">
      <video muted autoplay loop>
        <source :src="require('../assets/video/sy.mp4')" type="video/mp4" />
      </video>
      <transition enter-active-class="focus-in-expand">
        <p class="home-text" v-show="focus2">点击屏幕开始体验</p>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      focus2: false,
      showimg2: false
    }
  },
  inject: ['page'],
  mounted() {
    window.setTimeout(() => {
      this.focus2 = true
    }, 1000)
  },
  methods: {
    goToYu() {
      // this.page.hasMenu = true
      // window.setTimeout(() => {
      //   this.page.shouMenu = true
      // }, 1000)

      // this.page.$refs.bjm.play()
      this.$router.push({ name: 'yu' })
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  overflow: hidden;
  .home-con {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .home-text {
      position: absolute;
      bottom: 10px;
      width: 100%;
      font-size: 20px;
      letter-spacing: 2px;
      text-align: center;
    }
  }
}
.focus-in-expand {
  animation: focus-in-expand 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@keyframes focus-in-expand {
  0% {
    letter-spacing: -0.5em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@keyframes flicker {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
